import { render, staticRenderFns } from "./MgmBakara.vue?vue&type=template&id=47b85968&scoped=true&"
import script from "./MgmBakara.vue?vue&type=script&lang=js&"
export * from "./MgmBakara.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b85968",
  null
  
)

export default component.exports